import { render, staticRenderFns } from "./diamondWithType_DetailPop.vue?vue&type=template&id=2924802e&scoped=true"
import script from "./diamondWithType_DetailPop.vue?vue&type=script&lang=js"
export * from "./diamondWithType_DetailPop.vue?vue&type=script&lang=js"
import style0 from "./diamondWithType_DetailPop.vue?vue&type=style&index=0&id=2924802e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2924802e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2924802e')) {
      api.createRecord('2924802e', component.options)
    } else {
      api.reload('2924802e', component.options)
    }
    module.hot.accept("./diamondWithType_DetailPop.vue?vue&type=template&id=2924802e&scoped=true", function () {
      api.rerender('2924802e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/operationManagement/appNewRenovation/home/components/diamondWithType_DetailPop.vue"
export default component.exports